export const isUnclaimedCredit = (claimedAt?: string) => {
    if (!claimedAt) return true

    const normalized = claimedAt.trim().toLowerCase()
    if (normalized === '0' || normalized === 'zero') return true

    const parsed = Date.parse(claimedAt)
    return Number.isFinite(parsed) ? parsed <= 0 : false
}
